require('./cardAdditionalBeneficiaries.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
// @ constants
const { CARD_INTERVENTION_OWNER } = require('constants/index');

class CardAdditionalBeneficiaries extends React.Component {
    getBeneficiaries() {
        const { immCard } = this.props;
        const beneficiaries = immCard.get('interventionList');

        return beneficiaries.filter(
            beneficiary => beneficiary.get('interventionType') !== CARD_INTERVENTION_OWNER
        );
    }

    buildContent(beneficiaries) {
        return beneficiaries.map(beneficiary => {
            const beneficiaryName = beneficiary.get('name');
            const beneficiaryPan = beneficiary.get('pan');
            const key = `${beneficiaryName}${beneficiaryPan}`;

            return (
                <div className="card-additional-beneficiaries__beneficiary" key={key}>
                    <p className="card-additional-beneficiaries__beneficiary-name">
                        {beneficiaryName}
                    </p>
                    <OKInformativeListItem
                        title="cardDetails-additionalBeneficiariesPanNumber"
                        bodyText={beneficiaryPan}
                    />
                </div>
            );
        });
    }

    render() {
        const beneficiaries = this.getBeneficiaries();
        const content = this.buildContent(beneficiaries);

        return (
            <section>
                <OKInformativeList columns={2} title="cardDetails-additionalBeneficiariesTitle">
                    {content}
                </OKInformativeList>
            </section>
        );
    }
}

CardAdditionalBeneficiaries.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = CardAdditionalBeneficiaries;